<template>
  <section class="mb-64 job-carousel">
    <div class="job-carousel__clip">
      <div class="job-carousel__box">
        <ul class="job-carousel__main">
          <li>
            <a class="job-carousel__card" href="/job-post">
              <BabysitterIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Child care</span>
              <ArrowIcon />
            </a>
          </li>
          <li v-if="includeHousekeeping">
            <a class="job-carousel__card" href="/job_posting/new?care_type=housekeeping">
              <HousekeepingIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Housekeeping</span>
              <ArrowIcon />
            </a>
          </li>
          <li>
            <a class="job-carousel__card" href="/job_posting/new?care_type=pet_care">
              <PetCareIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Pet care</span>
              <ArrowIcon />
            </a>
          </li>
          <li>
            <a class="job-carousel__card" href="/job_posting/new?care_type=special_needs">
              <SpecialNeedsIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Special needs care</span>
              <ArrowIcon />
            </a>
          </li>
          <li>
            <a class="job-carousel__card" href="/job_posting/new?care_type=companion_care">
              <SeniorCareIllustration :width="56" :height="56" class="xs-vertical-spacing" />
              <span class="xs-vertical-spacing">Companion care</span>
              <ArrowIcon />
            </a>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import BabysitterIllustration from '@/graphics/illustrations/BabysitterIllustration.vue';
import PetCareIllustration from '@/graphics/illustrations/PetCareIllustration.vue';
import SeniorCareIllustration from '@/graphics/illustrations/SeniorCareIllustration.vue';
import SpecialNeedsIllustration from '@/graphics/illustrations/SpecialNeedsIllustration.vue';
import HousekeepingIllustration from '@/graphics/illustrations/HousekeepingIllustration.vue';
import ArrowIcon from '@/graphics/icons/ArrowIcon.vue';

export default {
  name: 'JobPostCarousel',
  components: {
    BabysitterIllustration,
    PetCareIllustration,
    SeniorCareIllustration,
    SpecialNeedsIllustration,
    HousekeepingIllustration,
    ArrowIcon,
  },
  props: {
    includeHousekeeping: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/stylesheets/variables/variables';

.job-carousel {
  /* clip and box combined are used to hide the scrollbars on mobile */
  &__clip {
    height: 175px;
    margin-bottom: 1rem;
    overflow: hidden;

    @media #{variables.$large-and-up} {
      height: auto;
      margin-bottom: 0;
      overflow: visible;
    }
  }

  &__box {
    height: 165px;
    box-sizing: content-box;
    padding: 0 0 2rem 0;
    position: relative;
    overflow-x: scroll;

    @media #{variables.$large-and-up} {
      height: auto;
      padding: 0;
      overflow: visible;
    }
  }

  &__main {
    display: flex;

    // allow last column's margin to extend outside the box
    width: calc(100% + 1rem);

    li {
      padding-right: 1rem;

      @media #{variables.$medium-and-up} {
        flex: 1 1 0;
      }
    }
  }

  &__card {
    align-items: center;
    background: variables.$white;
    border: 1px solid variables.$grey-20;
    border-radius: 4px;
    box-shadow: 0 2px 4px 0 rgba(5, 7, 15, 0.2);
    color: variables.$grey-60;
    display: flex;
    flex-flow: column nowrap;
    height: 163px;
    justify-content: space-between;
    padding: 1.5rem 0.25rem;
    text-align: center;
    transition: 0.5s box-shadow ease-in;
    width: 120px;

    @media #{variables.$medium-and-up} {
      min-width: 120px;
      width: 100%;
    }

    &:focus,
    &:hover {
      box-shadow: 0 4px 16px 0 rgba(5, 7, 15, 0.2);
    }

    &:focus {
      outline: 1px dotted variables.$primary-color-hover;
      outline-offset: 2px;
    }
  }
}
</style>
